import { TranslationHelper } from '@/context/Locale'
import { AsyncTechnicalColumnUpdateType } from '@/enums'
import { castCreateUsingPostBody } from '@/rtkApi'
import { logErrorAndNotifyWithToast } from '@/utils/errorHandling'

import { UpdateAndProcessTechnicalColumnsProps } from './types'

interface HandleTechnicalColumnsErrorProps {
	closeConfirmModal: () => void
	error: Error
	t: TranslationHelper
	technicalColumnId?: number
}

const handleTechnicalColumnsError = ({
	closeConfirmModal,
	error,
	t,
	technicalColumnId,
}: HandleTechnicalColumnsErrorProps) => {
	logErrorAndNotifyWithToast({
		error,
		context: {
			operation: 'technicalColumn.asyncUpdate',
			details: { technicalColumnId },
		},
		t,
		messageKey: 'TASK_START_ERROR',
	})
	closeConfirmModal()
}

export const updateAndProcessTechnicalColumns = async ({
	technicalColumn,
	postProcessTechnicalColumnDto,
	asyncTechnicalColumnUpdate,
	monitorTask,
	closeConfirmModal,
	t,
}: UpdateAndProcessTechnicalColumnsProps) => {
	try {
		const response = await asyncTechnicalColumnUpdate({
			body: castCreateUsingPostBody(technicalColumn),
			type: AsyncTechnicalColumnUpdateType.UPDATE_TECHNICAL_COLUMNS,
		})

		if (!response?.id) {
			throw new Error('Invalid response: missing task ID')
		}

	await monitorTask(response.id, {
		postProcessTechnicalColumnDto: () => {
			// Called when user clicks "Finish" button
			// This will close the init dialog via onClose()
			postProcessTechnicalColumnDto(technicalColumn)
			// Close the confirmation and progress dialogs
			closeConfirmModal()
		},
		onError: (error) =>
			handleTechnicalColumnsError({
				closeConfirmModal,
				error,
				t,
				technicalColumnId: technicalColumn?.id,
			}),
		dontCloseOnSuccess: true,
	})
	} catch (error) {
		return handleTechnicalColumnsError({
			closeConfirmModal,
			error: error as Error,
			t,
			technicalColumnId: technicalColumn?.id,
		})
	}
}
